import { ChargeConstantCollection } from "constants/charge/ChargeConstantCollection";

export const FSPUomDroOpts = (operatingUnit: string) => {

    const getAllFspUomModel = () => {
        return getFspUomModel(true);
    }

    const getFspUomNoHfDayModel = () => {
        return getFspUomModel(false);
    }

    const getFspUomModel = (showHfDay: boolean) => {
        let items = [];

        items.push(ChargeConstantCollection.uom.DAY);
        if (showHfDay && ("SAPT" === operatingUnit || "KICT" === operatingUnit)) {
            items.push(ChargeConstantCollection.uom.HFDAY);
        }

        items.push(ChargeConstantCollection.uom.HOUR);
        if ("AQCT" === operatingUnit || "OICT" === operatingUnit || "HPJZ" === operatingUnit || "RSCT" === operatingUnit) {
            items.push(ChargeConstantCollection.uom.MINUTE);
        }

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    const getFspUomModelForSpecialChg = (chargeType?: string, subChargeType?: string) => {
        let items = [];

        if ("RFH" === chargeType && "T1" === subChargeType) {
            items.push(ChargeConstantCollection.uom.DAY);
        }

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    return {
        getAllFspUomModel,
        //getFSPUomModelForSAPT,
        getFspUomNoHfDayModel,
        getFspUomModelForSpecialChg
    }
}